export const QA_NAME_ADD_RECIPIENT_BTN = 'AddRecipient'
